/* eslint-disable react/prop-types */
import React from 'react';

import { useConfigValue } from '~/shared/utils/config';
import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import {
  isCioColorFacet,
  isImageSwatchFacet,
  isProductsV2ColorFacet,
} from '../../utils/filters';

import MobileGridColorFilter from './MobileGridColorFilter';
import MobileGridColorWheelFilter from './MobileGridColorWheelFilter';
import MobileGridDefaultFilter from './MobileGridDefaultFilter';
import MobileGridFilterGroupDisclosure from './MobileGridFilterGroupDisclosure';
import MobileGridGroupedFilter from './MobileGridGroupedFilter';
import MobileGridImageFilter from './MobileGridImageFilter';

const MobileGridFilterRenderer = ({ facet, togglePanel, openPanels }) => {
  const { enabled: isColorWheelGridFilterEnabled } = useHasFeature(
    featureNames.COLOR_WHEEL_GRID_FILTER
  );
  const imageSwatchFilters = useConfigValue('public.imageSwatchFilters');

  if (facet?.sub_facets?.length > 0) {
    return (
      <MobileGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        <MobileGridGroupedFilter {...facet} />
      </MobileGridFilterGroupDisclosure>
    );
  }

  const shouldUseImageFilter = isImageSwatchFacet({
    facetName: facet?.name,
    imageSwatchFilters,
  });

  if (shouldUseImageFilter) {
    return (
      <MobileGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        <MobileGridImageFilter {...facet} />
      </MobileGridFilterGroupDisclosure>
    );
  }

  if (isCioColorFacet(facet?.name) || isProductsV2ColorFacet(facet?.name)) {
    return (
      <MobileGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        {isColorWheelGridFilterEnabled ? (
          <MobileGridColorWheelFilter {...facet} />
        ) : (
          <MobileGridColorFilter {...facet} />
        )}
      </MobileGridFilterGroupDisclosure>
    );
  }

  return (
    <MobileGridFilterGroupDisclosure
      {...facet}
      togglePanel={togglePanel}
      openPanels={openPanels}
    >
      <MobileGridDefaultFilter {...facet} />
    </MobileGridFilterGroupDisclosure>
  );
};

export default MobileGridFilterRenderer;
